export default __webpack_public_path__ + "locales/pt-BR/DeleteProfileEverDialog.json?hash=7b28371e420d689d2bb69400180df43a";